var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.982 10.978C18.8511 10.9796 18.7214 10.9538 18.6011 10.9023C18.4807 10.8507 18.3725 10.7745 18.2834 10.6786L10 2.41517L1.71657 10.6786C1.31736 11.0778 0.698603 11.0778 0.299401 10.6786C-0.0998004 10.2794 -0.0998004 9.66068 0.299401 9.26148L9.3014 0.299401C9.7006 -0.0998004 10.3194 -0.0998004 10.7186 0.299401L19.7006 9.28144C20.0998 9.68064 20.0998 10.2994 19.7006 10.6986C19.501 10.8982 19.2415 10.998 19.002 10.998L18.982 10.978Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/Up.cdb06b8283a358a3a6b34142b57ea6a4.svg";
export { ForwardRef as ReactComponent };